export default function FootprintAcrossAfrica() {
  return;
}